export default {
  SettingBaseDataCodeRule: {
    ruleCode: 'Rule Code',
    ruleName: 'Rule Name',

    table: {
      level: 'Level',
      tenant: 'Tenant',
      ruleCode: 'Rule Code',
      ruleName: 'Rule Name',
      ruleDescription: 'Rule Description',
    },

    edit: {
      msg: 'Account Information',
      code: 'Code Segment',
      type: 'Segment Type',
      value: 'Segment Value',
      data: 'Date Mask',
      min: 'Minimum Sequence Digits',
      start: 'Starting Sequence Value',
      editMin: 'Minimum Digits',
      editStart: 'Start Value',
      variable: 'Variable',
      number: 'Digits',
      editCode: 'Edit Code Segment',
      addCode: 'Create Code Segment'

    }
  }
};
